import React from 'react';
import styled from 'styled-components';

export const InputStyles = styled.input`
  height: 100%;
  background: #ffffff;

  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.neutral[40]};
  border-radius: 6px;
  outline: none;

  width: 100%;
  max-height: 40px;
  padding: 9px 20px 9px 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  box-sizing: border-box;

  color: ${({ theme }) => theme.colors.primary[100]};

  ::placeholder {
    color: ${({ theme }) => theme.colors.neutral[60]};
  }
  :focus {
    border-color: ${({ theme }) => theme.colors.primary[100]};
  }

  :hover {
    border-color: ${({ theme }) => theme.colors.primary[100]};
  }
`;
export const FormGroup = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  flex-direction: column;
  .error {
    border-color: red;
  }
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  color: #9297a2;
`;

export interface CustomTextProps {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  name: string;
  id?: string;
  label?: string;
  placeholder?: string;
  type: 'text' | 'email' | 'password';
  isError: boolean;
}

export const TextInput = (props: CustomTextProps) => {
  return (
    <FormGroup>
      {props.label && (
        <Label htmlFor={props.id || props.name}>{props.label}</Label>
      )}
      <InputStyles {...props} className={props.isError ? 'error' : ''} />
    </FormGroup>
  );
};
